import type { Mission } from '../missions.ts'

export const occ: Mission = {
  id: "occ",
  name: "Office of the Comptroller of the Currency",
  short: "OCC",
  call: "Banking",
  kind: "subagency",
  parent: "treasury",
  url: "https://www.occ.treas.gov/",
  established: 1863,
  palette: {
    primary: "#0071ba",
    secondary: "#005a9c",
    accent: "#efd763",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Office_of_the_Comptroller_of_the_Currency.svg",
  },
  motif: "key",
  mission: {
    text: "To ensure that national banks and federal savings associations operate in a safe and sound manner, provide fair access to financial services, treat customers fairly, and comply with applicable laws and regulations.",
    url: "https://www.occ.treas.gov/about/index-about.html",
  },
  fact: {
    text: "President Abraham Lincoln created the OCC on February 25, 1863, when he signed the National Currency Act to organize a system of nationally chartered banks and a uniform national currency.",
    url: "https://www.occ.treas.gov/about/index-about.html",
  },
  seal: {
    file: "public/seals/occ.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Office_of_the_Comptroller_of_the_Currency.svg",
  },
  identifier: {
    about: "https://www.occ.treas.gov/about/index-about.html",
    accessibility: "https://www.occ.treas.gov/about/policies/accessibility.html",
    foia: "https://www.occ.treas.gov/about/connect-with-us/foia/index-foia.html",
    noFear: "https://home.treasury.gov/footer/no-fear-act",
    oig: "https://oig.treasury.gov/",
    performance: "https://www.occ.treas.gov/publications-and-resources/publications/annual-report/index-annual-report.html",
    privacy: "https://www.occ.treas.gov/about/policies/web-privacy-policy.html",
  },
  media: {
    photos: [
      {
        file: "/media/occ-headquarters.jpg",
        small: "/media/occ-headquarters-sm.jpg",
        alt: "People walk past the stone facade and glass entrance of the Office of the Comptroller of the Currency, with the agency seal mounted on the wall.",
        title: "Office of the Comptroller of the Currency, Washington, D.C., June 21, 2024",
        creator: "ajay_suresh",
        source: "https://commons.wikimedia.org/wiki/File:The_Office_of_the_Comptroller_of_the_Currency_(OCC)_(53839145812).jpg",
        license: "CC BY 2.0",
      },
      {
        file: "/media/occ-wall-seal.jpg",
        small: "/media/occ-wall-seal-sm.jpg",
        alt: "The OCC seal, with its scales, chevron and key, cast in metal on a stone wall above the words Office of the Comptroller of the Currency.",
        title: "Seal of the Office of the Comptroller of the Currency outside its headquarters, Washington, D.C., February 10, 2025",
        creator: "G. Edward Johnson",
        source: "https://commons.wikimedia.org/wiki/File:Comptroller_of_the_Currency_wall_logo_Washington_DC_2025-02-10_13-19-10.jpg",
        license: "CC BY 4.0",
      },
    ],
  },
}
